import React from 'react'
import { ReactComponent as SphereHollow } from '../../images/pricing/new/hero-orb-hollow.svg'
import './styles.scss'

const FAQ = ({ data }) => {
  const {
    items,
    primary: { section_title: title }
  } = data[0]

  const toggleFaq = (e) => {
    const question = e.currentTarget
    const container = question.parentNode
    // const answer = question.nextSibling
    if (container.className.indexOf('open') < 0) {
      container.className += ' open'
      question.children[1].innerText = '-'
    } else {
      container.className = container.className.replace(' open', '')
      question.children[1].innerText = '+'
    }
  }

  return (
    <div className="faq-block">
      <div className="container">
        <div className="faq-block-container">
          <div className="faq-block-left">
            <h2>{title.text}</h2>
          </div>
          <div className="faq-block-right">
            <div className="faq-block-faq-container">
              {items.map((faq) => {
                const { faq_question: question, faq_answer: answer } = faq
                return (
                  <div key={question.text} className="faq-block-faq">
                    <h5 onClick={toggleFaq}>
                      <span className="faq-block-faq-text">{question.text} </span>
                      <span className="faq-block-faq-icon">+</span>
                    </h5>
                    <div className="faq-block-faq-answer" dangerouslySetInnerHTML={{ __html: answer.html }} />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
      <SphereHollow className="pricing-sphere-hollow" />
    </div>
  )
}

export default FAQ
